<template>
  <Modal
    v-model="visible"
    :title="modalTitle"
    :mask-closable="false"
    width="760"
    class-name="advertise-edit-modal"
    @on-cancel="handleCancel"
  >
    <Form
      v-if="visible"
      ref="formRef"
      :model="formData"
      :label-width="96"
      class="advertise-edit-form"
    >
      <FormItem label="推送人群">
        <RadioGroup
          v-model="formData.crowdMode"
          type="button"
          button-style="solid"
          :disabled="readonly"
          @on-change="handleCrowdModeChange"
        >
          <Radio label="all" :disabled="readonly">不限</Radio>
          <Radio label="selected" :disabled="readonly">选择人群包</Radio>
        </RadioGroup>
      </FormItem>

      <FormItem
        v-if="formData.crowdMode === 'selected'"
        label=""
        class="crowd-select-item"
      >
        <Select
          v-model="formData.crowdIds"
          multiple
          clearable
          filterable
          :disabled="readonly"
          style="width: 280px"
        >
          <Option
            v-for="item in resolvedCrowdOptions"
            :key="item.id"
            :value="item.id"
            :label="item.name"
          >
            <Poptip
              trigger="hover"
              placement="left"
              transfer
              word-wrap
              width="350"
            >
              <span>{{ item.name }}</span>
              <template #content>
                <div class="crowd-preview-card">
                  <div class="crowd-preview-title">{{ item.name }}</div>
                  <div class="crowd-preview-body">
                    <div
                      v-if="item.registerTimeDisplay"
                      class="crowd-preview-row"
                    >
                      <span class="crowd-preview-label">注册时间</span>
                      <span class="crowd-preview-value">
                        {{ item.registerTimeDisplay }}
                      </span>
                    </div>
                    <div v-if="item.payTypeName" class="crowd-preview-row">
                      <span class="crowd-preview-label">付费类型</span>
                      <span class="crowd-preview-value">
                        {{ item.payTypeName }}
                      </span>
                    </div>
                    <div
                      v-if="
                        item.todayLogin !== null &&
                        item.todayLogin !== undefined
                      "
                      class="crowd-preview-row"
                    >
                      <span class="crowd-preview-label">当日登录</span>
                      <span class="crowd-preview-value">
                        {{ item.todayLogin ? '是' : '否' }}
                      </span>
                    </div>
                    <div v-if="item.deviceSysName" class="crowd-preview-row">
                      <span class="crowd-preview-label">操作设备</span>
                      <span class="crowd-preview-value">
                        {{ item.deviceSysName }}
                      </span>
                    </div>
                    <div v-if="item.channelNames" class="crowd-preview-row">
                      <span class="crowd-preview-label">渠道</span>
                      <span class="crowd-preview-value">{{
                        item.channelNames
                      }}</span>
                    </div>
                    <div v-if="item.langNames" class="crowd-preview-row">
                      <span class="crowd-preview-label">语言</span>
                      <span class="crowd-preview-value">{{
                        item.langNames
                      }}</span>
                    </div>
                    <div v-if="item.countryNames" class="crowd-preview-row">
                      <span class="crowd-preview-label">国家</span>
                      <div class="crowd-country-text-wrapper">
                        <Tooltip
                          style="width: 100%; display: block"
                          :content="item.countryNames"
                          :max-width="300"
                          placement="top"
                          transfer
                        >
                          <span class="crowd-preview-value ellipsis-text">
                            {{ item.countryNames }}
                          </span>
                        </Tooltip>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </Poptip>
          </Option>
        </Select>
      </FormItem>

      <FormItem label="签到位广告" class="module-switch-item">
        <i-switch v-model="formData.signInAd.enabled" :disabled="readonly" />
      </FormItem>
      <FormItem
        v-if="formData.signInAd.enabled"
        label=""
        class="module-panel-item"
      >
        <div class="module-panel">
          <div class="panel-row">
            <div class="panel-label">广告展示</div>
            <div class="panel-content">
              <RadioGroup
                v-model="formData.signInAd.priority"
                :disabled="readonly"
              >
                <Radio label="only" :disabled="readonly">仅激励视频</Radio>
                <Radio label="video" :disabled="readonly">优先激励视频</Radio>
                <Radio label="h5" :disabled="readonly">优先H5</Radio>
              </RadioGroup>
            </div>
          </div>

          <div class="panel-row">
            <div class="panel-label">H5停留时长≥</div>
            <div class="panel-content panel-content--wrap">
              <InputNumber
                v-model="formData.signInAd.h5StaySeconds"
                :min="1"
                :max="60"
                :precision="0"
                :disabled="readonly"
                size="small"
              />
              <span class="panel-unit">秒</span>
            </div>
          </div>

          <div class="panel-row">
            <div class="panel-label"></div>
            <div class="panel-content panel-content--wrap">
              <span>每日可领</span>
              <InputNumber
                v-model="formData.signInAd.dailyLimit"
                :min="1"
                :max="99"
                :precision="0"
                :disabled="readonly"
                size="small"
              />
              <span class="panel-unit">次</span>

              <span class="panel-gap">每次需看</span>
              <InputNumber
                v-model="formData.signInAd.adsPerReward"
                :min="1"
                :max="20"
                :precision="0"
                :disabled="readonly"
                size="small"
              />
              <span class="panel-unit">条</span>
            </div>
          </div>

          <div class="panel-row reward-panel-row">
            <div class="panel-label">奖励赠币</div>
            <div class="panel-content reward-panel">
              <div
                v-for="(rule, index) in formData.signInAd.rewardRules"
                :key="index"
                class="reward-rule-row"
              >
                <span>{{ getRewardRuleNthText(index) }}</span>
                <span class="reward-label">奖励币数量</span>
                <InputNumber
                  v-model="rule.coinAmount"
                  :min="1"
                  :max="99999"
                  :precision="0"
                  :disabled="readonly"
                  size="small"
                />
                <Button
                  v-if="!readonly"
                  type="text"
                  class="reward-delete"
                  @click="removeRewardRule(index)"
                >
                  删除
                </Button>
              </div>
              <Button
                v-if="!readonly && canAddRewardRule"
                type="text"
                class="reward-add"
                @click="addRewardRule"
              >
                +添加规则
              </Button>
            </div>
          </div>
        </div>
      </FormItem>

      <FormItem label="剧集解锁广告" class="module-switch-item">
        <i-switch v-model="formData.unlockAd.enabled" :disabled="readonly" />
      </FormItem>
      <FormItem
        v-if="formData.unlockAd.enabled"
        label=""
        class="module-panel-item"
      >
        <div class="module-panel">
          <div class="panel-row">
            <div class="panel-label">广告展示</div>
            <div class="panel-content">
              <RadioGroup
                v-model="formData.unlockAd.priority"
                :disabled="readonly"
              >
                <Radio label="only" :disabled="readonly">仅激励视频</Radio>
                <Radio label="video" :disabled="readonly">优先激励视频</Radio>
                <Radio label="h5" :disabled="readonly">优先H5</Radio>
              </RadioGroup>
            </div>
          </div>

          <div class="panel-row">
            <div class="panel-label">H5停留时长≥</div>
            <div class="panel-content panel-content--wrap">
              <InputNumber
                v-model="formData.unlockAd.h5StaySeconds"
                :min="1"
                :max="60"
                :precision="0"
                :disabled="readonly"
                size="small"
              />
              <span class="panel-unit">秒</span>
            </div>
          </div>

          <div class="panel-row panel-row--wide-label">
            <div class="panel-label">
              <Tooltip transfer max-width="250" placement="right">
                <div slot="content">
                  <img
                    src="@/assets/images/tooltip/paywall-float.png"
                    style="width: 220px; border-radius: 4px"
                  />
                </div>
                <Icon
                  type="ios-information-circle-outline"
                  style="margin-right: 4px; color: #2d8cf0; cursor: pointer"
                />
              </Tooltip>
              付费面板悬浮窗
            </div>
            <div class="panel-content">
              <i-switch
                v-model="formData.unlockAd.payPanelFloat"
                :disabled="readonly"
              />
            </div>
          </div>

          <div class="panel-row">
            <div class="panel-label"></div>
            <div class="panel-content panel-content--wrap">
              <span>看</span>
              <InputNumber
                v-model="formData.unlockAd.adsPerUnlock"
                :min="1"
                :max="20"
                :precision="0"
                :disabled="readonly"
                size="small"
              />
              <span>个广告锁</span>
              <InputNumber
                v-model="formData.unlockAd.episodesPerUnlock"
                :min="1"
                :max="20"
                :precision="0"
                :disabled="readonly"
                size="small"
              />
              <span class="panel-unit">集</span>
            </div>
          </div>

          <div class="panel-row">
            <div class="panel-label"></div>
            <div class="panel-content panel-content--wrap">
              <span>每日最多解锁次数</span>
              <InputNumber
                v-model="formData.unlockAd.dailyUnlockLimit"
                :min="1"
                :max="99"
                :precision="0"
                :disabled="readonly"
                size="small"
              />
            </div>
          </div>
        </div>
      </FormItem>

      <FormItem label="开屏广告" class="module-switch-item">
        <i-switch v-model="formData.splashAd.enabled" :disabled="readonly" />
      </FormItem>
      <FormItem
        v-if="formData.splashAd.enabled"
        label=""
        class="module-panel-item"
      >
        <div class="module-panel module-panel--simple">
          <div class="panel-row">
            <div class="panel-label">广告类型</div>
            <div class="panel-content">
              <CheckboxGroup
                v-model="formData.splashAd.triggerTypes"
                :disabled="readonly"
              >
                <Checkbox label="cold" :disabled="readonly">冷启动</Checkbox>
                <Checkbox label="hot" :disabled="readonly">热启动</Checkbox>
              </CheckboxGroup>
            </div>
          </div>
        </div>
      </FormItem>

      <FormItem label="信息流广告" class="module-switch-item">
        <i-switch v-model="formData.feedAd.enabled" :disabled="readonly" />
      </FormItem>
      <FormItem
        v-if="formData.feedAd.enabled"
        label=""
        class="module-panel-item"
      >
        <div class="module-panel module-panel--simple">
          <div class="panel-row">
            <div class="panel-label">广告位置</div>
            <div class="panel-content">
              <CheckboxGroup
                v-model="formData.feedAd.positions"
                :disabled="readonly"
              >
                <Checkbox label="PLAY_PAGE" :disabled="readonly">
                  <Tooltip transfer max-width="250" placement="right">
                    <div slot="content">
                      <img
                        src="@/assets/images/tooltip/feed-play.jpg"
                        style="width: 220px; border-radius: 4px"
                      />
                    </div>
                    <Icon
                      type="ios-information-circle-outline"
                      style="margin-right: 2px; color: #2d8cf0; cursor: pointer"
                    />
                  </Tooltip>
                  播放页
                </Checkbox>
                <Checkbox label="ACTIVITY_PAGE" :disabled="readonly">
                  <Tooltip transfer max-width="250" placement="right">
                    <div slot="content">
                      <img
                        src="@/assets/images/tooltip/feed-activity.png"
                        style="width: 220px; border-radius: 4px"
                      />
                    </div>
                    <Icon
                      type="ios-information-circle-outline"
                      style="margin-right: 2px; color: #2d8cf0; cursor: pointer"
                    />
                  </Tooltip>
                  活动页
                </Checkbox>
              </CheckboxGroup>
            </div>
          </div>
        </div>
      </FormItem>

      <FormItem label="插屏广告" class="module-switch-item">
        <i-switch v-model="formData.interstitialAd.enabled" :disabled="readonly" />
      </FormItem>
      <FormItem
        v-if="formData.interstitialAd.enabled"
        label=""
        class="module-panel-item"
      >
        <div class="module-panel module-panel--simple">
          <div class="panel-row">
            <div class="panel-label">触发场景</div>
            <div class="panel-content">
              <CheckboxGroup
                v-model="formData.interstitialAd.triggerScenes"
                :disabled="readonly"
              >
                <Checkbox label="BACK_HOME" :disabled="readonly">返回主页</Checkbox>
                <Checkbox label="ACTIVITY_PAGE" :disabled="readonly">活动页</Checkbox>
                <Checkbox label="CLAIM_REWARD" :disabled="readonly">领奖励</Checkbox>
              </CheckboxGroup>
            </div>
          </div>
        </div>
      </FormItem>

      <FormItem
        label="广告配置名称"
        prop="strategyName"
        :rules="[
          { required: true, message: '请输入广告配置名称', trigger: 'blur' }
        ]"
      >
        <Input
          v-model="formData.strategyName"
          :maxlength="100"
          placeholder="仅用于后台显示"
          :disabled="readonly"
          style="width: 320px"
        />
      </FormItem>
    </Form>

    <template slot="footer" v-if="!readonly">
      <Button @click="handleCancel">取消</Button>
      <Button type="primary" :loading="loading" @click="handleSubmit">
        {{ submitButtonText }}
      </Button>
    </template>
  </Modal>
</template>

<script>
import { createAdStrategy, updateAdStrategy } from '@/api/advertise'

const PRIORITY_FORM_TO_API = {
  only:'ONLY_VIDEO',
  video: 'PRIORITY_VIDEO',
  h5: 'PRIORITY_H5'
}

const PRIORITY_API_TO_FORM = {
  ONLY_VIDEO: 'only',
  PRIORITY_VIDEO: 'video',
  PRIORITY_H5: 'h5'
}

const SPLASH_FORM_TO_API = {
  cold: 'COLD_START',
  hot: 'HOT_START'
}

const SPLASH_API_TO_FORM = {
  COLD_START: 'cold',
  HOT_START: 'hot'
}

const FEED_PLACEMENT_TO_FORM = {
  PLAY_PAGE: 'PLAY_PAGE',
  ACTIVITY_PAGE: 'ACTIVITY_PAGE',
  play: 'PLAY_PAGE',
  activity: 'ACTIVITY_PAGE'
}

const FEED_PLACEMENT_TO_API = {
  PLAY_PAGE: 'PLAY_PAGE',
  ACTIVITY_PAGE: 'ACTIVITY_PAGE',
  play: 'PLAY_PAGE',
  activity: 'ACTIVITY_PAGE'
}

const INTERSTITIAL_SCENARIO_TO_FORM = {
  BACK_HOME: 'BACK_HOME',
  ACTIVITY_PAGE: 'ACTIVITY_PAGE',
  CLAIM_REWARD: 'CLAIM_REWARD'
}

const INTERSTITIAL_SCENARIO_TO_API = {
  BACK_HOME: 'BACK_HOME',
  ACTIVITY_PAGE: 'ACTIVITY_PAGE',
  CLAIM_REWARD: 'CLAIM_REWARD'
}

const createDefaultForm = () => ({
  id: '',
  strategyName: '',
  crowdMode: 'all',
  crowdIds: [],
  crowdNamesText: '',
  signInAd: {
    enabled: false,
    priority: 'only',
    h5StayEnabled: true,
    h5StaySeconds: 15,
    dailyLimit: 1,
    adsPerReward: 1,
    rewardRules: [{ nth: 1, coinAmount: null }]
  },
  unlockAd: {
    enabled: false,
    priority: 'only',
    h5StayEnabled: true,
    h5StaySeconds: 15,
    payPanelFloat: false,
    adsPerUnlock: 1,
    episodesPerUnlock: 1,
    dailyUnlockLimit: 1
  },
  splashAd: {
    enabled: false,
    triggerTypes: ['cold']
  },
  feedAd: {
    enabled: false,
    positions: ['PLAY_PAGE']
  },
  interstitialAd: {
    enabled: false,
    triggerScenes: []
  }
})

const clone = (value) => JSON.parse(JSON.stringify(value))

const normalizePositiveNumber = (value, fallback) => {
  const nextValue = Number(value)
  if (Number.isFinite(nextValue) && nextValue > 0) {
    return nextValue
  }
  return fallback
}

const mapRewardRulesToForm = (rules, fallbackRules) => {
  if (!Array.isArray(rules) || !rules.length) return clone(fallbackRules)
  return rules.map((item, index) => ({
    nth: normalizePositiveNumber(
      item && (item.rangeStart || item.nth),
      index + 1
    ),
    coinAmount: normalizePositiveNumber(
      item && (item.coin || item.coinAmount),
      fallbackRules[0].coinAmount
    )
  }))
}

const buildRewardRulesPayload = (rules, dailyLimit) => {
  if (!Array.isArray(rules) || !rules.length) return []
  const total = dailyLimit || rules.length
  return rules.map((item, index) => {
    const rangeStart = index + 1
    const isLast = index === rules.length - 1
    const rangeEnd = isLast && rules.length < total ? total : rangeStart
    return {
      rangeStart,
      rangeEnd,
      coin: normalizePositiveNumber(item && item.coinAmount, 1)
    }
  })
}

const parseH5RewardConditions = (conditions, baseConfig) => {
  const nextConfig = {
    ...baseConfig,
    h5StayEnabled: true
  }

  if (!Array.isArray(conditions)) return nextConfig

  conditions.forEach((item) => {
    if (!item) return
    if (item.conditionType === 'DURATION') {
      nextConfig.h5StayEnabled = true
      nextConfig.h5StaySeconds = normalizePositiveNumber(
        item.conditionValue,
        baseConfig.h5StaySeconds
      )
    }
  })

  return nextConfig
}

const buildH5RewardConditionsPayload = (config) => {
  const conditions = []

  conditions.push({
    conditionType: 'DURATION',
    conditionValue: normalizePositiveNumber(config.h5StaySeconds, 1)
  })

  return conditions
}

const mapSignInConfigToForm = (config, baseConfig) => {
  const source = config || {}
  const nextConfig = parseH5RewardConditions(
    source.h5RewardConditions,
    baseConfig
  )

  return {
    ...nextConfig,
    priority:
      PRIORITY_API_TO_FORM[source.adSourcePriority] || baseConfig.priority,
    dailyLimit: normalizePositiveNumber(
      source.dailyLimit,
      baseConfig.dailyLimit
    ),
    adsPerReward: normalizePositiveNumber(
      source.adsPerReward,
      baseConfig.adsPerReward
    ),
    rewardRules: mapRewardRulesToForm(
      source.rewardRules,
      baseConfig.rewardRules
    )
  }
}

const buildSignInConfigPayload = (config) => ({
  adSourcePriority:
    PRIORITY_FORM_TO_API[config.priority] || PRIORITY_FORM_TO_API.video,
  adsPerReward: normalizePositiveNumber(config.adsPerReward, 1),
  dailyLimit: normalizePositiveNumber(config.dailyLimit, 1),
  h5RewardConditions: buildH5RewardConditionsPayload(config),
  rewardRules: buildRewardRulesPayload(config.rewardRules, config.dailyLimit)
})

const mapUnlockConfigToForm = (config, baseConfig) => {
  const source = config || {}
  const nextConfig = parseH5RewardConditions(
    source.h5RewardConditions,
    baseConfig
  )

  return {
    ...nextConfig,
    priority:
      PRIORITY_API_TO_FORM[source.adSourcePriority] || baseConfig.priority,
    payPanelFloat: Boolean(source.paywallFloatEnabled),
    adsPerUnlock: normalizePositiveNumber(
      source.adsRequired,
      baseConfig.adsPerUnlock
    ),
    episodesPerUnlock: normalizePositiveNumber(
      source.episodesUnlocked,
      baseConfig.episodesPerUnlock
    ),
    dailyUnlockLimit: normalizePositiveNumber(
      source.dailyLimit,
      baseConfig.dailyUnlockLimit
    )
  }
}

const buildUnlockConfigPayload = (config) => ({
  adSourcePriority:
    PRIORITY_FORM_TO_API[config.priority] || PRIORITY_FORM_TO_API.video,
  adsRequired: normalizePositiveNumber(config.adsPerUnlock, 1),
  dailyLimit: normalizePositiveNumber(config.dailyUnlockLimit, 1),
  episodesUnlocked: normalizePositiveNumber(config.episodesPerUnlock, 1),
  h5RewardConditions: buildH5RewardConditionsPayload(config),
  paywallFloatEnabled: Boolean(config.payPanelFloat)
})

const mapSplashConfigToForm = (config, baseConfig) => {
  const triggerScenarios = Array.isArray(config && config.triggerScenarios)
    ? config.triggerScenarios
        .map((item) => SPLASH_API_TO_FORM[item] || item)
        .filter(Boolean)
    : []

  return {
    ...baseConfig,
    triggerTypes: triggerScenarios.length
      ? triggerScenarios
      : clone(baseConfig.triggerTypes)
  }
}

const buildSplashConfigPayload = (config) => ({
  triggerScenarios: (config.triggerTypes || [])
    .map((item) => SPLASH_FORM_TO_API[item] || item)
    .filter(Boolean)
})

const mapFeedConfigToForm = (config, baseConfig) => {
  const positions = Array.isArray(config)
    ? config
    : Array.isArray(config && config.adPlacements)
    ? config.adPlacements
    : Array.isArray(config && config.positions)
    ? config.positions
    : []
  const normalizedPositions = positions
    .map((item) => FEED_PLACEMENT_TO_FORM[item] || item)
    .filter(Boolean)

  return {
    ...baseConfig,
    positions: normalizedPositions.length
      ? [...normalizedPositions]
      : clone(baseConfig.positions)
  }
}

const buildFeedConfigPayload = (config) => ({
  adPlacements: Array.isArray(config.positions)
    ? config.positions
        .map((item) => FEED_PLACEMENT_TO_API[item] || item)
        .filter(Boolean)
    : []
})

const mapInterstitialConfigToForm = (config, baseConfig) => {
  const triggerScenes = Array.isArray(config && config.triggerScenes)
    ? config.triggerScenes
        .map((item) => INTERSTITIAL_SCENARIO_TO_FORM[item] || item)
        .filter(Boolean)
    : []

  return {
    ...baseConfig,
    triggerScenes: triggerScenes.length
      ? triggerScenes
      : clone(baseConfig.triggerScenes)
  }
}

const buildInterstitialConfigPayload = (config) => ({
  triggerScenes: (config.triggerScenes || [])
    .map((item) => INTERSTITIAL_SCENARIO_TO_API[item] || item)
    .filter(Boolean)
})

export default {
  name: 'AdvertiseEditModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    },
    readonly: {
      type: Boolean,
      default: false
    },
    crowdOptions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      formData: createDefaultForm()
    }
  },
  computed: {
    modalTitle() {
      if (this.readonly) return '查看广告策略'
      return (this.formData.id ? '编辑' : '新增') + '广告策略'
    },
    submitButtonText() {
      return this.formData.id ? '保存' : '新增'
    },
    resolvedCrowdOptions() {
      const optionMap = new Map()
      ;(this.crowdOptions || []).forEach((item) => {
        optionMap.set(String(item.id), {
          ...item
        })
      })
      ;(this.formData.crowdIds || []).forEach((id) => {
        if (!optionMap.has(String(id))) {
          optionMap.set(String(id), {
            id,
            name: '人群包 ' + id
          })
        }
      })
      return Array.from(optionMap.values())
    },
    canAddRewardRule() {
      const dailyLimit = this.formData.signInAd.dailyLimit || 1
      return this.formData.signInAd.rewardRules.length < dailyLimit
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.visible = val
        if (val) {
          this.mapDataToForm(this.data)
        }
      }
    },
    visible(val) {
      this.$emit('input', val)
    },
    'formData.signInAd.dailyLimit'(val) {
      const limit = Number(val) || 1
      if (this.formData.signInAd.rewardRules.length > limit) {
        this.formData.signInAd.rewardRules =
          this.formData.signInAd.rewardRules.slice(0, limit)
      }
    }
  },
  methods: {
    getRewardRuleNthText(index) {
      const rules = this.formData.signInAd.rewardRules
      const dailyLimit = this.formData.signInAd.dailyLimit || rules.length
      const rangeStart = index + 1
      const isLast = index === rules.length - 1
      if (isLast && rules.length < dailyLimit) {
        return '第' + rangeStart + '~' + dailyLimit + '次'
      }
      return '第' + rangeStart + '次'
    },
    mapDataToForm(data) {
      const base = createDefaultForm()
      const source = data || {}
      const crowdType =
        source.crowdType === 0 || source.crowdMode === 'selected'
          ? 'selected'
          : 'all'

      this.formData = {
        ...base,
        id: source.id || '',
        strategyName: source.strategyName || source.name || '',
        crowdMode: crowdType,
        crowdIds: Array.isArray(source.crowdIds) ? [...source.crowdIds] : [],
        signInAd: {
          ...mapSignInConfigToForm(
            source.signInConfig || source.signInAd,
            base.signInAd
          ),
          enabled: Boolean(
            source.signInAdEnabled !== undefined
              ? source.signInAdEnabled
              : source.signInAd && source.signInAd.enabled
          )
        },
        unlockAd: {
          ...mapUnlockConfigToForm(
            source.episodeUnlockConfig || source.unlockAd,
            base.unlockAd
          ),
          enabled: Boolean(
            source.episodeUnlockAdEnabled !== undefined
              ? source.episodeUnlockAdEnabled
              : source.unlockAd && source.unlockAd.enabled
          )
        },
        splashAd: {
          ...mapSplashConfigToForm(
            source.splashAdConfig || source.splashAd,
            base.splashAd
          ),
          enabled: Boolean(
            source.splashAdEnabled !== undefined
              ? source.splashAdEnabled
              : source.splashAd && source.splashAd.enabled
          )
        },
        feedAd: {
          ...mapFeedConfigToForm(
            source.feedAdConfig || source.feedAd,
            base.feedAd
          ),
          enabled: Boolean(
            source.feedAdEnabled !== undefined
              ? source.feedAdEnabled
              : source.feedAd && source.feedAd.enabled
          )
        },
        interstitialAd: {
          ...mapInterstitialConfigToForm(
            source.interstitialAdConfig || source.interstitialAd,
            base.interstitialAd
          ),
          enabled: Boolean(
            source.interstitialAdEnabled !== undefined
              ? source.interstitialAdEnabled
              : source.interstitialAd && source.interstitialAd.enabled
          )
        }
      }
    },
    handleCrowdModeChange(value) {
      if (value === 'all') {
        this.formData.crowdIds = []
      }
    },
    addRewardRule() {
      if (!this.canAddRewardRule) return
      const newRule = { coinAmount: null }
      this.$set(this.formData.signInAd, 'rewardRules', [
        ...this.formData.signInAd.rewardRules,
        newRule
      ])
    },
    removeRewardRule(index) {
      if (this.formData.signInAd.rewardRules.length <= 1) {
        this.$Message.warning('至少保留一条奖励规则')
        return
      }
      this.formData.signInAd.rewardRules.splice(index, 1)
    },
    validatePositiveNumber(value) {
      return value !== null && value !== undefined && Number(value) > 0
    },

    validateRewardRules() {
      return (
        Array.isArray(this.formData.signInAd.rewardRules) &&
        this.formData.signInAd.rewardRules.length > 0 &&
        !this.formData.signInAd.rewardRules.some(
          (item) =>
            item.coinAmount === null ||
            item.coinAmount === undefined ||
            item.coinAmount === ''
        )
      )
    },
    validateStrategyForm() {
      if (
        this.formData.crowdMode === 'selected' &&
        (!this.formData.crowdIds || !this.formData.crowdIds.length)
      ) {
        this.$Message.error('请选择人群包')
        return false
      }

      if (this.formData.signInAd.enabled) {
        if (
          !this.validatePositiveNumber(this.formData.signInAd.dailyLimit) ||
          !this.validatePositiveNumber(this.formData.signInAd.adsPerReward)
        ) {
          this.$Message.error('请完善签到位广告配置')
          return false
        }
        if (
          !this.validatePositiveNumber(this.formData.signInAd.h5StaySeconds)
        ) {
          this.$Message.error('请输入有效的签到位广告停留时长')
          return false
        }

        if (!this.validateRewardRules()) {
          this.$Message.error('请完善签到位广告奖励赠币规则')
          return false
        }
      }

      if (this.formData.unlockAd.enabled) {
        if (
          !this.validatePositiveNumber(this.formData.unlockAd.adsPerUnlock) ||
          !this.validatePositiveNumber(
            this.formData.unlockAd.episodesPerUnlock
          ) ||
          !this.validatePositiveNumber(this.formData.unlockAd.dailyUnlockLimit)
        ) {
          this.$Message.error('请完善剧集解锁广告配置')
          return false
        }
        if (
          !this.validatePositiveNumber(this.formData.unlockAd.h5StaySeconds)
        ) {
          this.$Message.error('请输入有效的剧集解锁广告停留时长')
          return false
        }
      }

      if (
        this.formData.splashAd.enabled &&
        (!this.formData.splashAd.triggerTypes ||
          !this.formData.splashAd.triggerTypes.length)
      ) {
        this.$Message.error('请选择开屏广告类型')
        return false
      }

      if (
        this.formData.feedAd.enabled &&
        (!this.formData.feedAd.positions ||
          !this.formData.feedAd.positions.length)
      ) {
        this.$Message.error('请选择信息流广告位置')
        return false
      }

      if (
        this.formData.interstitialAd.enabled &&
        (!this.formData.interstitialAd.triggerScenes ||
          !this.formData.interstitialAd.triggerScenes.length)
      ) {
        this.$Message.error('请至少选择一个插屏广告触发场景')
        return false
      }

      return true
    },
    buildPayload() {
      const payload = {
        name: this.formData.strategyName,
        crowdType: this.formData.crowdMode === 'selected' ? 0 : -1,
        crowdIds:
          this.formData.crowdMode === 'selected'
            ? [...this.formData.crowdIds]
            : [],
        signInAdEnabled: Boolean(this.formData.signInAd.enabled),
        signInConfig: buildSignInConfigPayload(this.formData.signInAd),
        episodeUnlockAdEnabled: Boolean(this.formData.unlockAd.enabled),
        episodeUnlockConfig: buildUnlockConfigPayload(this.formData.unlockAd),
        splashAdEnabled: Boolean(this.formData.splashAd.enabled),
        splashAdConfig: buildSplashConfigPayload(this.formData.splashAd),
        feedAdEnabled: Boolean(this.formData.feedAd.enabled),
        feedAdConfig: buildFeedConfigPayload(this.formData.feedAd),
        interstitialAdEnabled: Boolean(this.formData.interstitialAd.enabled),
        interstitialAdConfig: buildInterstitialConfigPayload(this.formData.interstitialAd)
      }

      if (this.formData.id) {
        payload.id = this.formData.id
      }

      return payload
    },
    handleCancel() {
      this.visible = false
    },
    handleSubmit() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return
        if (!this.validateStrategyForm()) return

        this.loading = true
        try {
          const payload = this.buildPayload()
          const request = this.formData.id
            ? updateAdStrategy(payload)
            : createAdStrategy(payload)
          await request
          this.$Message.success('保存成功')
          this.visible = false
          this.$emit('on-success')
        } catch (error) {
          this.$Message.error('保存失败')
        } finally {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.advertise-edit-form {
  max-height: 68vh;
  overflow-y: auto;
  padding-right: 8px;
}

.crowd-select-item {
  margin-top: -6px;
}

.crowd-preview-card {
  white-space: normal;
}

.crowd-preview-title {
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 10px;
  color: #17233d;
  border-bottom: 1px solid #e8eaec;
  padding-bottom: 8px;
}

.crowd-preview-body {
  font-size: 13px;
}

.crowd-preview-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 6px;
  line-height: 1.5;
}

.crowd-preview-label {
  color: #808695;
  min-width: 70px;
  flex-shrink: 0;
}

.crowd-preview-label::after {
  content: '：';
}

.crowd-preview-value {
  color: #515a6e;
  word-break: break-all;
}

.crowd-country-text-wrapper {
  flex: 1;
  line-height: 1.5;
  min-width: 0;
}

.crowd-country-text-wrapper .ellipsis-text {
  display: block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.module-switch-item {
  margin-bottom: 10px;
}

.module-switch-item /deep/ .ivu-form-item-content {
  min-height: 24px;
  line-height: 24px;
}

.module-panel-item {
  margin-top: -2px;
  margin-bottom: 14px;
}

.module-panel {
  padding: 14px 16px 12px;
  background: #eef3fb;
  border-radius: 8px;
}

.module-panel--simple {
  padding-top: 12px;
  padding-bottom: 6px;
}

.panel-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
}

.panel-row:last-child {
  margin-bottom: 0;
}

.panel-row--wide-label .panel-label {
  width: 132px;
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.panel-label {
  width: 92px;
  line-height: 32px;
  color: #515a6e;
  flex-shrink: 0;
}

.panel-content {
  flex: 1;
  display: flex;
  align-items: center;
  min-height: 32px;
}

.panel-content--wrap {
  flex-wrap: wrap;
  gap: 8px;
}

.panel-unit {
  color: #808695;
}

.panel-gap {
  margin-left: 20px;
}

.reward-panel-row {
  align-items: flex-start;
}

.reward-panel {
  flex-direction: column;
  align-items: flex-start;
}

.reward-rule-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
}

.reward-rule-row:last-child {
  margin-bottom: 0;
}

.reward-label {
  margin-left: 8px;
}

.reward-add {
  padding-left: 0;
  color: #2d8cf0;
}

.reward-delete {
  padding-left: 0;
  color: #ed4014;
}
</style>

<style>
.ivu-poptip-body-content-word-wrap {
  white-space: normal !important;
  word-wrap: break-word !important;
  word-break: break-all !important;
}

.ivu-poptip-inner {
  white-space: normal !important;
}
</style>
